import React from "react";
import { Chip } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { useStyles } from "./filter-chip.styles";
import clsx from "clsx";

interface TypeChips {
  id: number;
  title: string;
}

interface FilterChipProps {
  data: TypeChips;
  setTypeChips: (chipsUpdater: (prevChips: TypeChips[]) => TypeChips[]) => void;
  className?: string;
}

export const FilterChip = ({
  data,
  setTypeChips,
  className,
}: FilterChipProps) => {
  const classes = useStyles();
  const handleChipDelete = (chipId: number) => {
    setTypeChips((prevChips) => prevChips.filter((chip) => chip.id !== chipId));
  };
  return (
    <Chip
      label={data.title}
      onDelete={() => handleChipDelete(data.id)}
      className={clsx(className, classes.chip)}
      deleteIcon={<HighlightOffIcon className={classes.deleteIcon} />}
    />
  );
};
